import imageRender from '../images/signup-page-thecheckin-io.jpg';
import Footer from './Common/Footer.js';
const BackgroundEntryPage = (props) =>{
        return(
            <div className="container-xxl mt-md-40 mt-10">
                <div className="col-md-12 mt-10">
                    <div className="row">
                        <div className="col-8 d-none d-md-block signup-bg-wrapper">
                            <img
                            src={imageRender}
                            alt="signup-page-background-thecheckinio"
                            />
                            <p className='signup-content mt-70'>Ready to experience <br/> how effortless attendance tracking can be?</p>
                            <p className='signup-content-highlight'>Sign up now</p>
                        </div>
                        <div className="col-md-3">
                            {props.children}
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
export default BackgroundEntryPage